import styles from "./skeleton.module.scss";
import { HTMLAttributes } from "react";
import classNames from "classnames";

export const Skeleton = (props: HTMLAttributes<HTMLDivElement>) => {
  const classes = classNames(styles.skeleton, styles.pulse);
  return <div {...props} className={classes} aria-hidden={true} />;
};
